// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

.adatmodositas-container {
    margin-top: 60px;
    min-height: 100vh;
    background-color: #f5f5f5;
    padding: 2rem;
}

.hero-section {
    background: white;
    padding: 3rem 2rem;
    text-align: center;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 3rem;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 3rem;
}

.hero-content {
    max-width: 800px;
    margin: 0 auto;
}

.hero-icon {
    width: 80px;
    height: 80px;
    background: #4CAF50;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 2rem auto;
}

.hero-icon i {
    font-size: 2.5rem;
    color: white;
}

.hero-content h1 {
    font-size: 2.5rem;
    margin: 0 0 1rem 0;
    font-weight: 600;
    color: #333;
}

.hero-content p {
    font-size: 1.2rem;
    margin: 0;
    color: #666;
    font-weight: 400;
}

.content-section {
    max-width: 1200px;
    margin: 0 auto;
}

.section-header {
    text-align: center;
    margin-bottom: 3rem;
}

.section-header h2 {
    font-size: 2rem;
    color: #333;
    margin: 0 0 1rem 0;
    font-weight: 600;
}

.section-header p {
    font-size: 1.1rem;
    color: #666;
    margin: 0;
}

.tiles-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 2rem;
}

.data-tile {
    background: white;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    min-height: 160px;
    border-left: 5px solid #ddd;
}

.data-tile:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.tile-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 5px;
    height: 100%;
    border-radius: 10px 0 0 10px;
}

.tile-content {
    padding: 2rem;
    display: flex;
    align-items: center;
    gap: 1.5rem;
    height: 100%;
}

.tile-icon {
    width: 60px;
    height: 60px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.tile-icon i {
    font-size: 1.8rem;
    color: white;
}

.tile-info {
    flex: 1 1;
}

.tile-info h3 {
    font-size: 1.4rem;
    color: #333;
    margin: 0 0 0.5rem 0;
    font-weight: 600;
}

.tile-info p {
    color: #666;
    margin: 0;
    line-height: 1.4;
    font-size: 1rem;
}

.tile-action {
    color: #ccc;
    transition: all 0.3s ease;
    font-size: 1.2rem;
}

.data-tile:hover .tile-action {
    color: #999;
    transform: translateX(4px);
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 1rem;
}

.modal-content {
    background: white;
    border-radius: 15px;
    width: 100%;
    max-width: 700px;
    max-height: 90vh;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    animation: modalSlideIn 0.3s ease;
}

@keyframes modalSlideIn {
    from {
        opacity: 0;
        transform: translateY(-50px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.modal-header {
    padding: 2rem;
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.modal-title {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.modal-title i {
    font-size: 2rem;
}

.modal-title h2 {
    margin: 0;
    font-size: 1.8rem;
    font-weight: 600;
}

.modal-title p {
    margin: 0.25rem 0 0 0;
    opacity: 0.9;
    font-size: 0.95rem;
}

.modal-close-button {
    background: rgba(0, 0, 0, 0.1);
    border: none;
    top: 35px;
    right: 35px; 
    margin: 15px;
    width: 50px ;
    height: 35px ;
    border-radius: 4px;
    cursor: pointer;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-close-button:hover {
    background: rgba(0, 0, 0, 0.2);
}

.modal-close-button i {
    font-size: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 20px;
    line-height: 20px;
}

.modal-body {
    padding: 2rem;
    overflow-y: auto;
}

.info-box {
    background: #f8f9fa;
    border-radius: 10px;
    padding: 1.5rem;
    margin-bottom: 2rem;
    display: flex;
    gap: 1rem;
    border-left: 4px solid #2196F3;
}

.info-box i {
    color: #2196F3;
    font-size: 1.5rem;
    flex-shrink: 0;
    margin-top: 0.1rem;
}

.info-box h4 {
    margin: 0 0 0.5rem 0;
    color: #333;
    font-size: 1.1rem;
}

.info-box ul {
    margin: 0;
    padding-left: 1.2rem;
    color: #666;
}

.info-box li {
    margin-bottom: 0.3rem;
    font-size: 0.9rem;
}

.file-upload-area {
    border: 2px dashed #ddd;
    border-radius: 10px;
    padding: 2rem;
    text-align: center;
    transition: all 0.3s ease;
}

.file-upload-area:hover {
    border-color: #2196F3;
    background: #fafafa;
}

.upload-zone {
    padding: 2rem 0;
}

.upload-zone i {
    font-size: 3rem;
    color: #bbb;
    margin-bottom: 1rem;
}

.upload-zone h3 {
    margin: 0 0 0.5rem 0;
    color: #333;
    font-size: 1.3rem;
}

.upload-zone p {
    margin: 0;
    color: #666;
}

.file-info {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 1rem;
    margin: 1rem 0;
}

.file-details {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.file-details i {
    font-size: 1.5rem;
}

.file-details > div:nth-child(2) {
    flex: 1 1;
}

.file-details strong {
    display: block;
    color: #333;
    font-size: 1rem;
}

.file-details span {
    color: #666;
    font-size: 0.85rem;
}

.file-status {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    font-size: 0.85rem;
    font-weight: 500;
}

.file-status.success {
    color: #4CAF50;
}

.upload-actions {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    margin-top: 1rem;
    flex-wrap: wrap;
}

.upload-actions .btn {
    min-width: 140px;
    height: 40px;
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
}

.btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    transition: all 0.3s ease;
    text-decoration: none;
    justify-content: center;
    min-width: 140px;
    height: 40px;
    margin: 5px 5px 0 0;
}

.btn-secondary {
    background: #6c757d;
    color: white;
}

.btn-secondary:hover {
    background: #5a6268;
}

.btn-primary {
    background: #4CAF50;
    color: white;
}

.btn-primary:hover:not(:disabled) {
    background: #45a049;
}

.btn:disabled {
    background: #ccc;
    color: #666;
    cursor: not-allowed;
}

.spinner {
    width: 16px;
    height: 16px;
    border: 2px solid transparent;
    border-top: 2px solid currentColor;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .adatmodositas-container {
        padding: 1rem;
    }
    
    .hero-content h1 {
        font-size: 2rem;
    }
    
    .hero-content p {
        font-size: 1.1rem;
    }
    
    .tiles-grid {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }
    
    .tile-content {
        padding: 1.5rem;
    }
    
    .modal-content {
        margin: 1rem;
        max-width: calc(100% - 2rem);
    }
    
    .modal-header,
    .modal-body {
        padding: 1.5rem;
    }
    
    .upload-actions {
        flex-direction: column;
        align-items: stretch;
    }
    
    .btn {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .hero-section {
        padding: 2rem 1rem;
    }
    
    .section-header h2 {
        font-size: 1.8rem;
    }
    
    .tile-content {
        flex-direction: column;
        text-align: center;
        gap: 1rem;
    }
    
    .tile-action {
        align-self: center;
    }
}

/* Deselect button styling */
.file-details {
    display: flex;
    align-items: center;
    gap: 1rem;
    position: relative;
    color: red !important;

}

.deselect-button {
    background: transparent;
    border: none;
    width: 24px;
    height: 24px;
    cursor: pointer;
    color: red !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    flex-shrink: 0;
}

.deselect-button:hover {
    background: transparent !important;
    color: red !important;
    transform: none !important;
    box-shadow: none !important;
    border: none !important;
}


.deselect-button i {
    font-size: 14px;
}

/* File icon styling */
.file-icon {
    font-size: 24px !important;
    flex-shrink: 0;
}

/* Notification styles */
.notification {
    position: fixed;
    top: 80px;
    right: 20px;
    max-width: 500px;
    min-width: 300px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    animation: slideIn 0.3s ease-out;
    border-left: 4px solid;
}

.notification-success {
    border-left-color: #4CAF50;
}

.notification-error {
    border-left-color: #f44336;
}

.notification-info {
    border-left-color: #2196F3;
}

.notification-content {
    padding: 16px;
}

.notification-header {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 8px;
}

.notification-icon {
    flex-shrink: 0;
    margin-top: 2px;
}

.notification-icon i {
    font-size: 20px;
}

.notification-success .notification-icon i {
    color: #4CAF50;
}

.notification-error .notification-icon i {
    color: #f44336;
}

.notification-info .notification-icon i {
    color: #2196F3;
}

.notification-message {
    flex: 1 1;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.4;
    color: #333;
}

.notification-close {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: #666;
    font-size: 18px;
    flex-shrink: 0;
    margin-top: -2px;
}

.notification-close:hover {
    color: #333;
}

.notification-details {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #eee;
    font-size: 13px;
    color: #666;
}

.notification-details pre {
    background: #f5f5f5;
    padding: 8px;
    border-radius: 4px;
    white-space: pre-wrap;
    margin: 0;
    font-family: inherit;
    font-size: 12px;
}

.validation-details h4 {
    margin: 0 0 8px 0;
    font-size: 13px;
    font-weight: 600;
    color: #333;
}

.validation-details ul {
    margin: 0 0 12px 0;
    padding-left: 20px;
}

.validation-details li {
    margin-bottom: 4px;
    font-size: 12px;
    line-height: 1.4;
}

.expected-structure {
    margin-top: 12px;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 4px;
}

.headers-comparison {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-top: 8px;
}

.expected-headers,
.actual-headers {
    font-size: 12px;
}

.expected-headers strong,
.actual-headers strong {
    display: block;
    margin-bottom: 6px;
    font-size: 13px;
    color: #333;
}

.expected-headers ol,
.actual-headers ol {
    margin: 0;
    padding-left: 18px;
}

.expected-headers li,
.actual-headers li {
    margin-bottom: 2px;
    padding: 2px 0;
}

.expected-headers {
    border-right: 1px solid #ddd;
    padding-right: 12px;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

/* Responsive notification */
@media (max-width: 768px) {
    .notification {
        left: 20px;
        right: 20px;
        max-width: none;
        min-width: auto;
    }
    
    .headers-comparison {
        grid-template-columns: 1fr;
        gap: 12px;
    }
    
    .expected-headers {
        border-right: none;
        border-bottom: 1px solid #ddd;
        padding-right: 0;
        padding-bottom: 12px;
    }
}

/* Period Management Styles */
.period-management-section {
    max-width: 1200px;
    margin: 3rem auto 0;
    text-align: center;
}

.btn-period-management {
    background: linear-gradient(135deg, #607D8B 0%, #455A64 100%);
    color: white;
    border: none;
    padding: 0.6rem 1.5rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.3s ease;
    box-shadow: 0 3px 10px rgba(96, 125, 139, 0.3);
    height: 40px;
}

.period-modal-content {
    max-width: 1000px;
    max-height: 90vh;
}

.period-form-section {
    margin-bottom: 2rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid #eee;
}

.period-form-section h3 {
    margin: 0 0 1.5rem 0;
    color: #333;
    font-size: 1.3rem;
}

.period-form {
    background: #fafafa;
    padding: 1.5rem;
    border-radius: 10px;
    border: 1px solid #eee;
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    margin-bottom: 1rem;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.form-group label {
    font-weight: 500;
    color: #333;
    font-size: 0.95rem;
}

.form-group input[type="text"],
.form-group input[type="date"] {
    padding: 0.75rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 1rem;
    transition: all 0.3s ease;
}

.form-group input:focus {
    outline: none;
    border-color: #607D8B;
    box-shadow: 0 0 0 3px rgba(96, 125, 139, 0.1);
}

.form-group input:disabled {
    background: #f5f5f5;
    color: #999;
}

.checkbox-group {
    margin: 1rem 0;
}

.checkbox-group label {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    cursor: pointer;
    font-weight: 500;
    color: #333;
    font-size: 0.95rem;
}

.checkbox-group input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: #607D8B;
}

.field-error {
    color: #f44336;
    font-size: 0.8rem;
    margin-top: 0.25rem;
}

.form-group input.error,
.form-group input[aria-invalid="true"] {
    border-color: #f44336;
}

.form-group input.error:focus {
    box-shadow: 0 0 0 3px rgba(244, 67, 54, 0.1);
}

.form-actions {
    display: flex;
    gap: 0.5rem;
    justify-content: flex-end;
    margin-top: 1rem;
    flex-wrap: wrap;
}

.form-actions .btn {
    min-width: 100px;
    height: 36px;
    padding: 0.4rem 0.8rem;
    font-size: 0.85rem;
}

.period-list-section h3 {
    margin: 0 0 1.5rem 0;
    color: #333;
    font-size: 1.3rem;
}

.loading-periods,
.no-periods {
    text-align: center;
    padding: 3rem;
    color: #666;
}

.loading-periods .spinner {
    margin: 0 auto 1rem;
}

.periods-table-container {
    overflow-x: auto;
}

.periods-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.periods-table th,
.periods-table td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid #eee;
}

.periods-table th {
    background: #f8f9fa;
    font-weight: 600;
    color: #333;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.periods-table tbody tr {
    transition: background 0.2s ease;
}

.periods-table tbody tr:hover {
    background: #f8f9fa;
}

.periods-table tbody tr.active-period {
    background: #e8f5e9;
}

.periods-table tbody tr.active-period:hover {
    background: #c8e6c9;
}

.status-badge {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.status-badge.active {
    background: #e8f5e9;
    color: #2e7d32;
}

.status-badge.inactive {
    background: #f5f5f5;
    color: #757575;
}

.action-buttons {
    display: flex;
    gap: 0.3rem;
}

.btn-icon {
    background: transparent;
    border: none;
    width: 30px;
    height: 30px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    color: #666;
}

.btn-icon:hover:not(:disabled) {
    background: #f0f0f0;
}

.btn-icon.edit:hover:not(:disabled) {
    background: #e3f2fd;
    color: #1976d2;
}

.btn-icon.delete:hover:not(:disabled) {
    background: #fbe9e7;
    color: #d32f2f;
}

.btn-icon:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.btn-icon i {
    font-size: 1rem;
}

/* Responsive for period modal */
@media (max-width: 768px) {
    .period-modal-content {
        margin: 1rem;
        max-width: calc(100% - 2rem);
        max-height: calc(100vh - 2rem);
    }
    
    .modal-header,
    .modal-body {
        padding: 1.5rem;
    }
    
    .form-row {
        grid-template-columns: 1fr;
    }
    
    .period-form {
        padding: 1rem;
    }
    
    .periods-table-container {
        margin: 0 -1.5rem;
        padding: 0 1.5rem;
    }
    
    .periods-table th,
    .periods-table td {
        padding: 0.75rem 0.5rem;
        font-size: 0.85rem;
    }
    
    .form-actions {
        flex-direction: column;
    }
    
    .form-actions .btn {
        width: 100%;
    }
    
    .btn-period-management {
        width: 100%;
        justify-content: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/routes/AdatModositas.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;IAC1C,iCAAiC;AACrC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,SAAS;IACT,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,kCAAkC;IAClC,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;QAC1B,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,4BAA4B;IAChC;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qBAAqB;;AAEzB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;AAC3B;;;AAGA;IACI,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,WAAW;IACX,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,SAAS;IACT,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA,4BAA4B;AAC5B;IACI;QACI,UAAU;QACV,WAAW;QACX,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,6BAA6B;QAC7B,gBAAgB;QAChB,oBAAoB;IACxB;AACJ;;AAEA,6BAA6B;AAC7B;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,8CAA8C;IAC9C,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI;QACI,YAAY;QACZ,4BAA4B;QAC5B,8BAA8B;IAClC;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;;QAEI,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\n.adatmodositas-container {\n    margin-top: 60px;\n    min-height: 100vh;\n    background-color: #f5f5f5;\n    padding: 2rem;\n}\n\n.hero-section {\n    background: white;\n    padding: 3rem 2rem;\n    text-align: center;\n    border-radius: 10px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    margin-bottom: 3rem;\n    max-width: 1200px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 3rem;\n}\n\n.hero-content {\n    max-width: 800px;\n    margin: 0 auto;\n}\n\n.hero-icon {\n    width: 80px;\n    height: 80px;\n    background: #4CAF50;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 2rem auto;\n}\n\n.hero-icon i {\n    font-size: 2.5rem;\n    color: white;\n}\n\n.hero-content h1 {\n    font-size: 2.5rem;\n    margin: 0 0 1rem 0;\n    font-weight: 600;\n    color: #333;\n}\n\n.hero-content p {\n    font-size: 1.2rem;\n    margin: 0;\n    color: #666;\n    font-weight: 400;\n}\n\n.content-section {\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.section-header {\n    text-align: center;\n    margin-bottom: 3rem;\n}\n\n.section-header h2 {\n    font-size: 2rem;\n    color: #333;\n    margin: 0 0 1rem 0;\n    font-weight: 600;\n}\n\n.section-header p {\n    font-size: 1.1rem;\n    color: #666;\n    margin: 0;\n}\n\n.tiles-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    gap: 2rem;\n}\n\n.data-tile {\n    background: white;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    position: relative;\n    min-height: 160px;\n    border-left: 5px solid #ddd;\n}\n\n.data-tile:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n.tile-background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 5px;\n    height: 100%;\n    border-radius: 10px 0 0 10px;\n}\n\n.tile-content {\n    padding: 2rem;\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n    height: 100%;\n}\n\n.tile-icon {\n    width: 60px;\n    height: 60px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.tile-icon i {\n    font-size: 1.8rem;\n    color: white;\n}\n\n.tile-info {\n    flex: 1;\n}\n\n.tile-info h3 {\n    font-size: 1.4rem;\n    color: #333;\n    margin: 0 0 0.5rem 0;\n    font-weight: 600;\n}\n\n.tile-info p {\n    color: #666;\n    margin: 0;\n    line-height: 1.4;\n    font-size: 1rem;\n}\n\n.tile-action {\n    color: #ccc;\n    transition: all 0.3s ease;\n    font-size: 1.2rem;\n}\n\n.data-tile:hover .tile-action {\n    color: #999;\n    transform: translateX(4px);\n}\n\n/* Modal Styles */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 1rem;\n}\n\n.modal-content {\n    background: white;\n    border-radius: 15px;\n    width: 100%;\n    max-width: 700px;\n    max-height: 90vh;\n    overflow: hidden;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n    animation: modalSlideIn 0.3s ease;\n}\n\n@keyframes modalSlideIn {\n    from {\n        opacity: 0;\n        transform: translateY(-50px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.modal-header {\n    padding: 2rem;\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.modal-title {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.modal-title i {\n    font-size: 2rem;\n}\n\n.modal-title h2 {\n    margin: 0;\n    font-size: 1.8rem;\n    font-weight: 600;\n}\n\n.modal-title p {\n    margin: 0.25rem 0 0 0;\n    opacity: 0.9;\n    font-size: 0.95rem;\n}\n\n.modal-close-button {\n    background: rgba(0, 0, 0, 0.1);\n    border: none;\n    top: 35px;\n    right: 35px; \n    margin: 15px;\n    width: 50px ;\n    height: 35px ;\n    border-radius: 4px;\n    cursor: pointer;\n    color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.modal-close-button:hover {\n    background: rgba(0, 0, 0, 0.2);\n}\n\n.modal-close-button i {\n    font-size: 25px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 20px;\n    width: 20px;\n    line-height: 20px;\n}\n\n.modal-body {\n    padding: 2rem;\n    overflow-y: auto;\n}\n\n.info-box {\n    background: #f8f9fa;\n    border-radius: 10px;\n    padding: 1.5rem;\n    margin-bottom: 2rem;\n    display: flex;\n    gap: 1rem;\n    border-left: 4px solid #2196F3;\n}\n\n.info-box i {\n    color: #2196F3;\n    font-size: 1.5rem;\n    flex-shrink: 0;\n    margin-top: 0.1rem;\n}\n\n.info-box h4 {\n    margin: 0 0 0.5rem 0;\n    color: #333;\n    font-size: 1.1rem;\n}\n\n.info-box ul {\n    margin: 0;\n    padding-left: 1.2rem;\n    color: #666;\n}\n\n.info-box li {\n    margin-bottom: 0.3rem;\n    font-size: 0.9rem;\n}\n\n.file-upload-area {\n    border: 2px dashed #ddd;\n    border-radius: 10px;\n    padding: 2rem;\n    text-align: center;\n    transition: all 0.3s ease;\n}\n\n.file-upload-area:hover {\n    border-color: #2196F3;\n    background: #fafafa;\n}\n\n.upload-zone {\n    padding: 2rem 0;\n}\n\n.upload-zone i {\n    font-size: 3rem;\n    color: #bbb;\n    margin-bottom: 1rem;\n}\n\n.upload-zone h3 {\n    margin: 0 0 0.5rem 0;\n    color: #333;\n    font-size: 1.3rem;\n}\n\n.upload-zone p {\n    margin: 0;\n    color: #666;\n}\n\n.file-info {\n    background: #f8f9fa;\n    border-radius: 8px;\n    padding: 1rem;\n    margin: 1rem 0;\n}\n\n.file-details {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.file-details i {\n    font-size: 1.5rem;\n}\n\n.file-details > div:nth-child(2) {\n    flex: 1;\n}\n\n.file-details strong {\n    display: block;\n    color: #333;\n    font-size: 1rem;\n}\n\n.file-details span {\n    color: #666;\n    font-size: 0.85rem;\n}\n\n.file-status {\n    display: flex;\n    align-items: center;\n    gap: 0.3rem;\n    font-size: 0.85rem;\n    font-weight: 500;\n}\n\n.file-status.success {\n    color: #4CAF50;\n}\n\n.upload-actions {\n    display: flex;\n    gap: 0.5rem;\n    justify-content: center;\n    margin-top: 1rem;\n    flex-wrap: wrap;\n}\n\n.upload-actions .btn {\n    min-width: 140px;\n    height: 40px;\n    padding: 0.5rem 1rem;\n    font-size: 0.9rem;\n}\n\n.btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 1rem;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 0.9rem;\n    font-weight: 500;\n    transition: all 0.3s ease;\n    text-decoration: none;\n    justify-content: center;\n    min-width: 140px;\n    height: 40px;\n    margin: 5px 5px 0 0;\n}\n\n.btn-secondary {\n    background: #6c757d;\n    color: white;\n}\n\n.btn-secondary:hover {\n    background: #5a6268;\n}\n\n.btn-primary {\n    background: #4CAF50;\n    color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n    background: #45a049;\n}\n\n.btn:disabled {\n    background: #ccc;\n    color: #666;\n    cursor: not-allowed;\n}\n\n.spinner {\n    width: 16px;\n    height: 16px;\n    border: 2px solid transparent;\n    border-top: 2px solid currentColor;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .adatmodositas-container {\n        padding: 1rem;\n    }\n    \n    .hero-content h1 {\n        font-size: 2rem;\n    }\n    \n    .hero-content p {\n        font-size: 1.1rem;\n    }\n    \n    .tiles-grid {\n        grid-template-columns: 1fr;\n        gap: 1.5rem;\n    }\n    \n    .tile-content {\n        padding: 1.5rem;\n    }\n    \n    .modal-content {\n        margin: 1rem;\n        max-width: calc(100% - 2rem);\n    }\n    \n    .modal-header,\n    .modal-body {\n        padding: 1.5rem;\n    }\n    \n    .upload-actions {\n        flex-direction: column;\n        align-items: stretch;\n    }\n    \n    .btn {\n        width: 100%;\n    }\n}\n\n@media (max-width: 480px) {\n    .hero-section {\n        padding: 2rem 1rem;\n    }\n    \n    .section-header h2 {\n        font-size: 1.8rem;\n    }\n    \n    .tile-content {\n        flex-direction: column;\n        text-align: center;\n        gap: 1rem;\n    }\n    \n    .tile-action {\n        align-self: center;\n    }\n}\n\n/* Deselect button styling */\n.file-details {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    position: relative;\n    color: red !important;\n\n}\n\n.deselect-button {\n    background: transparent;\n    border: none;\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    color: red !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: auto;\n    flex-shrink: 0;\n}\n\n.deselect-button:hover {\n    background: transparent !important;\n    color: red !important;\n    transform: none !important;\n    box-shadow: none !important;\n    border: none !important;\n}\n\n\n.deselect-button i {\n    font-size: 14px;\n}\n\n/* File icon styling */\n.file-icon {\n    font-size: 24px !important;\n    flex-shrink: 0;\n}\n\n/* Notification styles */\n.notification {\n    position: fixed;\n    top: 80px;\n    right: 20px;\n    max-width: 500px;\n    min-width: 300px;\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n    z-index: 1000;\n    animation: slideIn 0.3s ease-out;\n    border-left: 4px solid;\n}\n\n.notification-success {\n    border-left-color: #4CAF50;\n}\n\n.notification-error {\n    border-left-color: #f44336;\n}\n\n.notification-info {\n    border-left-color: #2196F3;\n}\n\n.notification-content {\n    padding: 16px;\n}\n\n.notification-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin-bottom: 8px;\n}\n\n.notification-icon {\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.notification-icon i {\n    font-size: 20px;\n}\n\n.notification-success .notification-icon i {\n    color: #4CAF50;\n}\n\n.notification-error .notification-icon i {\n    color: #f44336;\n}\n\n.notification-info .notification-icon i {\n    color: #2196F3;\n}\n\n.notification-message {\n    flex: 1;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 1.4;\n    color: #333;\n}\n\n.notification-close {\n    background: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    color: #666;\n    font-size: 18px;\n    flex-shrink: 0;\n    margin-top: -2px;\n}\n\n.notification-close:hover {\n    color: #333;\n}\n\n.notification-details {\n    margin-top: 12px;\n    padding-top: 12px;\n    border-top: 1px solid #eee;\n    font-size: 13px;\n    color: #666;\n}\n\n.notification-details pre {\n    background: #f5f5f5;\n    padding: 8px;\n    border-radius: 4px;\n    white-space: pre-wrap;\n    margin: 0;\n    font-family: inherit;\n    font-size: 12px;\n}\n\n.validation-details h4 {\n    margin: 0 0 8px 0;\n    font-size: 13px;\n    font-weight: 600;\n    color: #333;\n}\n\n.validation-details ul {\n    margin: 0 0 12px 0;\n    padding-left: 20px;\n}\n\n.validation-details li {\n    margin-bottom: 4px;\n    font-size: 12px;\n    line-height: 1.4;\n}\n\n.expected-structure {\n    margin-top: 12px;\n    padding: 12px;\n    background: #f8f9fa;\n    border-radius: 4px;\n}\n\n.headers-comparison {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    margin-top: 8px;\n}\n\n.expected-headers,\n.actual-headers {\n    font-size: 12px;\n}\n\n.expected-headers strong,\n.actual-headers strong {\n    display: block;\n    margin-bottom: 6px;\n    font-size: 13px;\n    color: #333;\n}\n\n.expected-headers ol,\n.actual-headers ol {\n    margin: 0;\n    padding-left: 18px;\n}\n\n.expected-headers li,\n.actual-headers li {\n    margin-bottom: 2px;\n    padding: 2px 0;\n}\n\n.expected-headers {\n    border-right: 1px solid #ddd;\n    padding-right: 12px;\n}\n\n@keyframes slideIn {\n    from {\n        transform: translateX(100%);\n        opacity: 0;\n    }\n    to {\n        transform: translateX(0);\n        opacity: 1;\n    }\n}\n\n/* Responsive notification */\n@media (max-width: 768px) {\n    .notification {\n        left: 20px;\n        right: 20px;\n        max-width: none;\n        min-width: auto;\n    }\n    \n    .headers-comparison {\n        grid-template-columns: 1fr;\n        gap: 12px;\n    }\n    \n    .expected-headers {\n        border-right: none;\n        border-bottom: 1px solid #ddd;\n        padding-right: 0;\n        padding-bottom: 12px;\n    }\n}\n\n/* Period Management Styles */\n.period-management-section {\n    max-width: 1200px;\n    margin: 3rem auto 0;\n    text-align: center;\n}\n\n.btn-period-management {\n    background: linear-gradient(135deg, #607D8B 0%, #455A64 100%);\n    color: white;\n    border: none;\n    padding: 0.6rem 1.5rem;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 0.95rem;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    transition: all 0.3s ease;\n    box-shadow: 0 3px 10px rgba(96, 125, 139, 0.3);\n    height: 40px;\n}\n\n.period-modal-content {\n    max-width: 1000px;\n    max-height: 90vh;\n}\n\n.period-form-section {\n    margin-bottom: 2rem;\n    padding-bottom: 2rem;\n    border-bottom: 1px solid #eee;\n}\n\n.period-form-section h3 {\n    margin: 0 0 1.5rem 0;\n    color: #333;\n    font-size: 1.3rem;\n}\n\n.period-form {\n    background: #fafafa;\n    padding: 1.5rem;\n    border-radius: 10px;\n    border: 1px solid #eee;\n}\n\n.form-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n    margin-bottom: 1rem;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n\n.form-group label {\n    font-weight: 500;\n    color: #333;\n    font-size: 0.95rem;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"date\"] {\n    padding: 0.75rem;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 1rem;\n    transition: all 0.3s ease;\n}\n\n.form-group input:focus {\n    outline: none;\n    border-color: #607D8B;\n    box-shadow: 0 0 0 3px rgba(96, 125, 139, 0.1);\n}\n\n.form-group input:disabled {\n    background: #f5f5f5;\n    color: #999;\n}\n\n.checkbox-group {\n    margin: 1rem 0;\n}\n\n.checkbox-group label {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    cursor: pointer;\n    font-weight: 500;\n    color: #333;\n    font-size: 0.95rem;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    accent-color: #607D8B;\n}\n\n.field-error {\n    color: #f44336;\n    font-size: 0.8rem;\n    margin-top: 0.25rem;\n}\n\n.form-group input.error,\n.form-group input[aria-invalid=\"true\"] {\n    border-color: #f44336;\n}\n\n.form-group input.error:focus {\n    box-shadow: 0 0 0 3px rgba(244, 67, 54, 0.1);\n}\n\n.form-actions {\n    display: flex;\n    gap: 0.5rem;\n    justify-content: flex-end;\n    margin-top: 1rem;\n    flex-wrap: wrap;\n}\n\n.form-actions .btn {\n    min-width: 100px;\n    height: 36px;\n    padding: 0.4rem 0.8rem;\n    font-size: 0.85rem;\n}\n\n.period-list-section h3 {\n    margin: 0 0 1.5rem 0;\n    color: #333;\n    font-size: 1.3rem;\n}\n\n.loading-periods,\n.no-periods {\n    text-align: center;\n    padding: 3rem;\n    color: #666;\n}\n\n.loading-periods .spinner {\n    margin: 0 auto 1rem;\n}\n\n.periods-table-container {\n    overflow-x: auto;\n}\n\n.periods-table {\n    width: 100%;\n    border-collapse: collapse;\n    background: white;\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.periods-table th,\n.periods-table td {\n    padding: 1rem;\n    text-align: left;\n    border-bottom: 1px solid #eee;\n}\n\n.periods-table th {\n    background: #f8f9fa;\n    font-weight: 600;\n    color: #333;\n    font-size: 0.9rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.periods-table tbody tr {\n    transition: background 0.2s ease;\n}\n\n.periods-table tbody tr:hover {\n    background: #f8f9fa;\n}\n\n.periods-table tbody tr.active-period {\n    background: #e8f5e9;\n}\n\n.periods-table tbody tr.active-period:hover {\n    background: #c8e6c9;\n}\n\n.status-badge {\n    display: inline-block;\n    padding: 0.25rem 0.75rem;\n    border-radius: 20px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.status-badge.active {\n    background: #e8f5e9;\n    color: #2e7d32;\n}\n\n.status-badge.inactive {\n    background: #f5f5f5;\n    color: #757575;\n}\n\n.action-buttons {\n    display: flex;\n    gap: 0.3rem;\n}\n\n.btn-icon {\n    background: transparent;\n    border: none;\n    width: 30px;\n    height: 30px;\n    border-radius: 4px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    color: #666;\n}\n\n.btn-icon:hover:not(:disabled) {\n    background: #f0f0f0;\n}\n\n.btn-icon.edit:hover:not(:disabled) {\n    background: #e3f2fd;\n    color: #1976d2;\n}\n\n.btn-icon.delete:hover:not(:disabled) {\n    background: #fbe9e7;\n    color: #d32f2f;\n}\n\n.btn-icon:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.btn-icon i {\n    font-size: 1rem;\n}\n\n/* Responsive for period modal */\n@media (max-width: 768px) {\n    .period-modal-content {\n        margin: 1rem;\n        max-width: calc(100% - 2rem);\n        max-height: calc(100vh - 2rem);\n    }\n    \n    .modal-header,\n    .modal-body {\n        padding: 1.5rem;\n    }\n    \n    .form-row {\n        grid-template-columns: 1fr;\n    }\n    \n    .period-form {\n        padding: 1rem;\n    }\n    \n    .periods-table-container {\n        margin: 0 -1.5rem;\n        padding: 0 1.5rem;\n    }\n    \n    .periods-table th,\n    .periods-table td {\n        padding: 0.75rem 0.5rem;\n        font-size: 0.85rem;\n    }\n    \n    .form-actions {\n        flex-direction: column;\n    }\n    \n    .form-actions .btn {\n        width: 100%;\n    }\n    \n    .btn-period-management {\n        width: 100%;\n        justify-content: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
